import React, { FC, useMemo } from 'react'

import { ProductContext } from '@Components/Product/Context'
import GiftCardDisplayV2 from '@Domains/Product/Features/GiftCard/GiftCardDisplay/GiftCardDisplay'
import { Block, Field, Product } from '@Generated/graphql'
import { getProductFieldValue, getReferenceFieldValue } from '@Globals/CMS/FieldHelpers'

export interface GiftCardBlockProps {
  giftCardBlock: Block
}

const getBlockProduct = ({ fields }: Block): Product | null => {
  const reference: { fields: Field[] }[] = getReferenceFieldValue(fields!, 'product') ?? []
  return getProductFieldValue(reference[0]?.fields, 'product') ?? null
}

const GiftCardBlock: FC<GiftCardBlockProps> = ({ giftCardBlock }) => {
  const product = useMemo(() => getBlockProduct(giftCardBlock), [giftCardBlock])

  // TODO: This has to work better.
  if (!product) {
    return <>404</>
  }

  return (
    <ProductContext.Provider value={product}>
      <GiftCardDisplayV2 />
    </ProductContext.Provider>
  )
}
export default GiftCardBlock
